import React from 'react';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import Content from 'Views/Page/Content/Modal/Layouts/UploadOrSelectFromSecureFilesStepLayout/Content';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

export default function UploadOrSelectFromSecureFilesTemplate({ resource }) {
  const { setPageContentCollection } = usePageContentContext();

  return <>
    <WizardStepWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={() => <Content setCollection={setPageContentCollection} />}
    />
  </>;
}
